export const errorData = {
    401: {
        "category": "User Authorization",
        "message": "Not authorized. Unable to resolve user profile or user not properly provisioned."
    },
    1001: {
        "category": "API Response Timeout",
        "message": "Unable to communicate with data service."
    },
    1002: {
        "category": "Access Denied",
        "message": "Your account is not permitted to access this resource. Please restart the application and do not attempt to navigate directly to restricted URLs."
    }
}